import { useQuery } from "@tanstack/react-query";

import type { Customer } from "@shared/schemas/entities";
import type {
  RankedEntity,
  RankedResponse,
} from "@shared/schemas/ranking";

import { apiGet } from "@/lib/api/client";
import { queryKeys } from "@/lib/query/keys";

export type RankedCustomer = RankedEntity<Customer>;

interface RankedCustomersResponse {
  ok: true;
  data: RankedResponse<Customer>;
}

export function useRankedCustomers() {
  return useQuery({
    queryKey: queryKeys.customers.ranked(),
    queryFn: async () => {
      const res = await apiGet<RankedCustomersResponse>(
        "/api/customers/ranked",
      );
      return res.data;
    },
  });
}
